/**
 * Sanitizes phone numbers for logging by showing only the last 4 digits
 * for enhanced privacy compliance while maintaining debugging capability.
 *
 * @param phoneNumber - The phone number to sanitize
 * @returns Sanitized phone number showing only last 4 digits with "****" prefix
 *
 * @example
 * sanitizePhoneNumberForLogging('+15551234567') // '****4567'
 * sanitizePhoneNumberForLogging('555-123-4567') // '****4567'
 * sanitizePhoneNumberForLogging('1234') // '****1234'
 * sanitizePhoneNumberForLogging('123') // '****123'
 */
export function sanitizePhoneNumberForLogging(phoneNumber: string): string {
  if (!phoneNumber) return phoneNumber;

  // Extract only digits from the phone number
  const digitsOnly = phoneNumber.replace(/\D/g, '');

  // If no digits found, return the original
  if (!digitsOnly) return phoneNumber;

  // Show only last 4 digits with **** prefix
  const lastFourDigits = digitsOnly.slice(-4);

  return `****${lastFourDigits}`;
}
